export class PaymentsEditConfiguration {

    Oid?: number;
    UserOid? : number;
    WorkOrderOid? : number;
    /**
     * OID della Company associata al WorkOrder corrente. Usato quando il dialog
     * di edit/create viene aperto dal tab Fatturazione del work-order: in quel
     * contesto il campo `Company` viene rimosso dal form (deriva dal work-order),
     * ma il backend ha comunque bisogno del riferimento esplicito al Company.Oid
     * nel payload. Lo passa il caller (vedi WorkOrderPaymentsComponent) leggendolo
     * direttamente dal viewModel.workOrder già caricato in pagina (senza chiamate
     * API aggiuntive).
     */
    CompanyOid? : number;
    constructor() {}

    public static create = (): PaymentsEditConfiguration => new PaymentsEditConfiguration();

    public setOid (oid: number): PaymentsEditConfiguration
    {
        this.Oid = oid;
        return this;
    }
    public setUserOid (oid: number): PaymentsEditConfiguration
    {
        this.UserOid = oid;
        return this;
    }

    public setWorkOrderOid (oid: number): PaymentsEditConfiguration
    {
        this.WorkOrderOid = oid;
        return this;
    }

    public setCompanyOid (oid: number): PaymentsEditConfiguration
    {
        this.CompanyOid = oid;
        return this;
    }
}

